/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { useReactiveVar } from '@apollo/client';
import { useCustomer } from '@components/contexts/CustomerContext';
import { seasonVar } from '@graphql/cache';
import { Dropdown } from '@mayoral/ui';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { FC } from 'react';

import { seasonsToOptions } from './sidebar.utils';

import { Routes } from '@/lib/constants';

const SidebarSeasonSelector: FC = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const { customer } = useCustomer();
  const season = useReactiveVar(seasonVar);
  const options = seasonsToOptions(customer?.seasons, t);

  // When no options are available, set the value to an empty string
  // to avoid selecting a non-available option.
  const value = options.length === 0 ? '' : season.value;

  const handleChange = async (e) => {
    if (router.pathname === Routes.PACKING_LIST_DETAILS) {
      await router.push(Routes.PACKING_LIST);
    }

    const value = e.target.value;
    const newSeason = customer.seasons.find((item) => item.value === value);
    seasonVar(newSeason);
  };

  return (
    <Dropdown
      value={value}
      options={options}
      disabled={options.length === 0}
      onChange={handleChange}
      sx={{ height: 36 }}
    />
  );
};

export default SidebarSeasonSelector;
